module.exports = __webpack_public_path__ + "img/mode_outline_1.efee4a38.png";